import React from "react";
import { func } from "prop-types";
import { connect } from "react-redux";
import { showModal } from "ducks/modals.js"; // eslint-disable-line import/no-extraneous-dependencies
import {
  Row,
  Col,
  Button,
  Table,
  FormGroup,
  ControlLabel,
  FormControl,
  InputGroup,
  DropdownButton,
  MenuItem,
} from "react-bootstrap";
import ContentWrapper from "../../layout/ContentWrapper";
import { table } from "./table";

const Statistics = ({ handleOpenNewEmployeeModal }) => (
  <ContentWrapper>
    <div className="content-heading">Statistics</div>
    <Row>
      <Col xs={12}>
        <div className="stacked-filter-panel">
          <FormGroup controlId="role" className="city-filter">
            <ControlLabel>Role:</ControlLabel>
            <FormControl componentClass="select" placeholder="All">
              <option value="select">All</option>
              <option value="other">...</option>
            </FormControl>
          </FormGroup>
          <FormGroup controlId="stage" className="stage-filter">
            <ControlLabel>Status:</ControlLabel>
            <FormControl componentClass="select" placeholder="All">
              <option value="select">All</option>
              <option value="other">...</option>
            </FormControl>
          </FormGroup>
          <FormGroup className="search-filter">
            <ControlLabel>Search:</ControlLabel>
            <InputGroup>
              <FormControl type="text" />
              <InputGroup.Button>
                <Button>
                  <i className="fa fa-search" aria-hidden="true" />
                </Button>
              </InputGroup.Button>
            </InputGroup>
          </FormGroup>
          <Button bsStyle="primary" onClick={handleOpenNewEmployeeModal}>
            <i className="fa fa-plus" aria-hidden="true" /> Add new
          </Button>
        </div>
      </Col>
    </Row>
    <Row>
      <Col xs={12}>
        <Table striped>
          <thead>
            <tr>
              <th>Name</th>
              <th>Role</th>
              <th>Subdivision</th>
              <th>Phone Numeber</th>
              <th style={{ width: "60px" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {table &&
              table.map((item, key) => (
                <tr key={key}>
                  <td>
                    <a href="#">{item.name}</a>
                  </td>
                  <td>{item.role}</td>
                  <td>
                    <a href="#">{item.subdivision}</a>
                  </td>
                  <td>{item.phoneNumber}</td>
                  <td>
                    <DropdownButton pullRight noCaret title={<i className="fa fa-angle-right" />} id={"employeesActionBtn" + key}>
                      <MenuItem eventKey="1">
                        <i className="fa fa-commenting-o text-muted mr-sm" />Message
                      </MenuItem>
                      <MenuItem eventKey="2">
                        <i className="fa fa-pencil text-muted mr-sm" />Edit
                      </MenuItem>
                      <MenuItem eventKey="3">
                        <i className="fa fa-clock-o text-muted mr-sm" />Time Off
                      </MenuItem>
                      <MenuItem eventKey="4">
                        <i className="fa fa-times-circle text-muted mr-sm" />Mark as Inactive
                      </MenuItem>
                    </DropdownButton>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </Col>
    </Row>
  </ContentWrapper>
);

Statistics.propTypes = {
  handleOpenNewEmployeeModal: func,
};

const mapDispatchToProps = dispatch => ({
  handleOpenNewEmployeeModal: () => dispatch(showModal("ADD_NEW_EMPLOYEE")),
});

export default connect(null, mapDispatchToProps)(Statistics);

 


// WEBPACK FOOTER //
// ./src/components/pages/Statistics/index.js